module.exports = __webpack_public_path__ + "static/media/rainbow-notice.6b0a673c.png";